import { render } from "./SliderComponent.vue?vue&type=template&id=22f2dbe2"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"

import "./SliderComponent.vue?vue&type=style&index=0&id=22f2dbe2&lang=css"

import exportComponent from "/home/runner/work/leadsbroker-anketa/leadsbroker-anketa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__